/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Kantor_NInputs */

const en_tut_kantor_n = /** @type {(inputs: Tut_Kantor_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entering only shares your avatar and position. Audio starts only after you choose it, and the camera only on a meeting page. Presence expires by itself when the connection drops, so nobody stays visibly "present" with a closed laptop.`)
};

const id_tut_kantor_n = /** @type {(inputs: Tut_Kantor_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk kantor hanya membagikan avatar dan posisi. Audio baru aktif setelah Anda memilihnya, kamera hanya di halaman rapat. Kehadiran kedaluwarsa otomatis saat koneksi terputus, jadi tidak ada orang yang terlihat hadir padahal laptopnya sudah tertutup.`)
};

/**
* | output |
* | --- |
* | "Entering only shares your avatar and position. Audio starts only after you choose it, and the camera only on a meeting page. Presence expires by itself when ..." |
*
* @param {Tut_Kantor_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_kantor_n = /** @type {((inputs?: Tut_Kantor_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Kantor_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_kantor_n(inputs)
	return en_tut_kantor_n(inputs)
});